import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

const Root = styled.button`
  border: none;
  border-radius: 0;
  padding: 11px 17px;
  line-height: 1.3;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  
  ${({size}) => size === 'normal'
    ? css`
      background-color: #6fb971;
      color: white;
      font-family: Merriweather, serif;    
      font-size: 13px;
      font-weight: 400;

      &:hover {
        background-color: #4ec152;
      }
    ` : css`
      padding: 0;
      background-color: transparent;
      color: #2d9831;
      font-family: raleway, sans-serif;
      font-size: 12px;
      font-weight: 600;
    `
  };
  
  &:focus {
    outline: none;
  }
`
const Button = ({
  children,
  clickHandler,
  size = 'normal'
}) => <Root onClick={clickHandler} size={size}>
  {children}
</Root>

export default Button




